<template>
  <div class="field free-drawing">
    <label :for="name">{{label}} <em class="optional" v-if="!required">optional</em><em class="required" v-if="required">*</em></label>
    <div class="draw-canvas-wrapper" @click="canvasExport" @touchend="canvasExport">
      <canvas class="draw-canvas" :width="width" :height="height"></canvas>
      <a class="draw-canvas-clear icon yule-icon-refresh" @click="canvasClean"></a>
    </div>
    <div class="draw-canvas-navigation">
      <div class="btn draw-canvas-navigation--left" :class="{'is-disabled': !leftScrollable}" @click="scroll(-50)">left</div>
      <div class="btn draw-canvas-navigation--right" :class="{'is-disabled': !rightScrollable}" @click="scroll(50)">right</div>
    </div>
    <p v-if="error" class="validation-message">{{$t(error)}}</p>
  </div>
</template>
<script>
import SignaturePad from 'signature_pad'

export default {
  props: {
    label: String,
    classes: Array,
    name: String,
    value: String,
    required: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
      newValue: String,
      error: "",
      canvas: null,
      wrapper: null,
      signaturePad: null,
      width: 1026,
      height: 450,
      viewportWidth: Number,
      leftScrollable: Boolean,
      rightScrollable: Boolean
    }
  },
  methods:{
    canvasClean(){
      this.signaturePad.clear()
    },
    canvasExport(){
      this.newValue = JSON.stringify(this.signaturePad.toData())
    },
    displayCanvas(){
      this.signaturePad = new SignaturePad(this.canvas)
      this.$nextTick(function () {
        if(typeof this.value != 'undefined'){
          try {
            if (this.value) {
              this.signaturePad.fromData(JSON.parse(this.value))
            }
          } catch (error) {
            console.log(error)
          }
        }
      })
    },
    scroll(offset){
      let left = this.wrapper.scrollLeft
      this.wrapper.scrollTo(left + parseInt(offset),0)
      this.leftScrollable = this.isLeftScrollable()
      this.rightScrollable = this.isRightScrollable()
    },
    isLeftScrollable(){
      if(this.wrapper.scrollLeft == 0){
        return false
      }else{
        return true
      }
    },
    isRightScrollable(){
      this.viewportWidth = this.wrapper.offsetWidth
      if((this.viewportWidth + this.wrapper.scrollLeft) >= this.width){
        return false
      }else{
        return true
      }
    },
    init(){
      this.canvas = document.querySelector(".draw-canvas")
      this.displayCanvas()
      this.wrapper = document.querySelector(".draw-canvas-wrapper")
      this.viewportWidth = this.wrapper.offsetWidth
      this.scroll(0)
    }
  },
  created () {
    this.newValue = this.value
  },
  mounted(){
    this.init()
  },
  watch: {
    value() {
      this.newValue = this.value
      this.displayCanvas()
      this.init()
    },
    newValue () {
      this.$emit('input', this.newValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.free-drawing {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
label{
  display: block;
  margin-bottom: 6px !important;
  padding-bottom: 0 !important;
}
.draw-canvas-wrapper{
  position: relative;
  user-select: none;
  max-width: 100%;
  overflow: hidden;
  // overflow-x: auto;
  transition: all 400ms ease;
}
.draw-canvas {
  width: 99.9999%;
  background-color: white;
  border: 1px solid #e6e6e6;
  // margin: 1em;
}
.draw-canvas-clear{
  background: #e6e6e6;
  position: absolute;
  border-radius: 50px;
  top: 0px;
  right: 0px;
  z-index: 5;
  padding: 5px;
}
.draw-canvas-navigation{
  display: flex;
  justify-content: space-between
}
.draw-canvas-navigation--left,.draw-canvas-navigation--right{
  &.is-disabled{
    opacity: 0.5;
    cursor:default;
  }
}

</style>



// WEBPACK FOOTER //
// FreeDrawing.vue?705383c7